import { computed, type ComputedRef } from "vue";
import { useRoute } from "vue-router";
interface EmptyStateConfig {
  title: string;
  description: string;
  icon: string;
}
/** * Composable that provides empty state configuration based on current route * Follows the "Extract Single-Use Composables" pattern for better code organization */ export const useEmptyStateConfig =
  (): ComputedRef<EmptyStateConfig> => {
    const route = useRoute();
    return computed((): EmptyStateConfig => {
      const currentPage = route.name as string;
      const currentTabList = route.query.tabList as string;
      const isMyRequestsPage = currentPage === "myRequests";
      const isServiceTab = ["active-service", "completed-service"].includes(
        currentTabList,
      );
      const isActiveProjectsTab = currentTabList === "active-projects";
      if (isMyRequestsPage) {
        return {
          title: "Ingen forespørsler",
          description:
            "Det er ingen forespørsler å vise i denna kategorien enda.",
          icon: "pi-inbox",
        };
      }
      if (isServiceTab) {
        return {
          title: "Ingen serviceavtaler",
          description:
            "Det er ingen serviceavtaler å vise i denna kategorien enda.",
          icon: "pi-inbox",
        };
      }
      return {
        title: "Ingen prosjekter",
        description: isActiveProjectsTab
          ? "Det er ingen prosjekter å vise i denna kategorien enda."
          : "Det er ingen prosjekter å vise i denna kategorien enda.",
        icon: "pi-inbox",
      };
    });
  };
